export const DELIVERY_METHODS = {
  TAKE_AWAY: "TAKE_AWAY",
  ON_SITE: "ON_SITE",
};
